import React, { useEffect, useState } from 'react';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';
import useTooth from '../../Hooks/Tooth/useTooth';
import {
	ToothLesionType,
	ToothPathologyRootDecayValues,
	ToothPresence,
} from '../../../../graphql/graphql';

const DENTModalOverviewPathologyRootDecay = () => {
	const {
		pathology: { rootDecay },
	} = useTooth();

	const [values, setValues] = useState<
		ToothPathologyRootDecayValues | undefined
	>(rootDecay.values);

	useEffect(() => {
		if (values) rootDecay.setValues(values);
	}, [values]);

	const handleChangePresence = (value: ToothPresence) => {
		setValues(prev =>
			prev?.presence === value
				? {
						presence: undefined,
						lesionType: undefined,
				  }
				: {
						presence: value,
						lesionType:
							value === ToothPresence.No ? undefined : prev?.lesionType,
				  },
		);
	};

	const handleChangeLesionType = (value: ToothLesionType) => {
		setValues(prev =>
			prev?.lesionType === value
				? {
						...prev,
						lesionType: undefined,
				  }
				: { ...prev, lesionType: value },
		);
	};

	const rows = [
		{
			shouldHide: false,
			items: [
				{
					title: 'base.yes',
					isSelected: values?.presence === ToothPresence.Yes,
					onClick: () => handleChangePresence(ToothPresence.Yes),
				},
				{
					title: 'base.no',
					isSelected: values?.presence === ToothPresence.No,
					onClick: () => handleChangePresence(ToothPresence.No),
				},
			],
		},
		{
			shouldHide: values?.presence !== ToothPresence.Yes,
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.rootDecay.lesionTypeDentin',
					isSelected: values?.lesionType === ToothLesionType.Dentin,
					onClick: () => handleChangeLesionType(ToothLesionType.Dentin),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.rootDecay.lesionTypeCement',
					isSelected: values?.lesionType === ToothLesionType.Cement,
					onClick: () => handleChangeLesionType(ToothLesionType.Cement),
				},
			],
		},
	];

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewPathologyRootDecay;
